export default __webpack_public_path__ + "static/media/card-4.e787cd02.webp";